// extracted by mini-css-extract-plugin
export default {"root":"RXN18LJl6E","root_details":"tPWVcnMxMB"};